export function customerRatingMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      customerRatingId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateCustomerRatingId(json) {
  return {
    data: {...json, id: json.objectId,customerRatingId:json.objectId},
  };
}
export function fixGetManyCustomerRating(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateCustomerRatingId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function customerRatingMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, customerRatingId: json.result.objectId},
  };
}